<template>
    <div class="container py-5">
        <h2>{{ $t('settings') }}</h2>
        <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <RouterLink to="/dataspaces">
                            {{ $t('home') }}    
                        </RouterLink>
                    </li>
                    <li v-if="this.$route.name === 'dataspaces'" class="breadcrumb-item">
                        {{ $t('dataspaces') }}
                    </li>
                    <li v-else-if="this.$route.name === 'users'" class="breadcrumb-item">
                        {{ $t('users') }}
                    </li>
                    <li v-else-if="this.$route.name === 'groups'" class="breadcrumb-item">
                        {{ $t('groups') }}
                    </li>
                </ol>
            </nav>
        <div class="row">   
            <div class="col-3">
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <RouterLink to="/settings/dataspaces" v-bind:class="['nav-link', this.checkIfActive('dataspaces')]" id="dataspaces" 
                        data-toggle="pill" role="tab" href="#dataspaces" aria-controls="dataspaces" aria-selected="false">
                        {{ $t('dataspaces') }}
                    </RouterLink>
                    <RouterLink to="/settings/users" id="users" data-toggle="pill"
                        role="tab" aria-selected="true" href="#users" v-bind:class="['nav-link', this.checkIfActive('users')]" >
                        {{ $t('users') }}
                    </RouterLink>
                    <RouterLink to="/settings/groups" v-bind:class="['nav-link', this.checkIfActive('groups')]" id="groups" 
                        data-toggle="pill" role="tab" aria-controls="groups" aria-selected="false">
                        {{ $t('groups') }}
                    </RouterLink>
                </div>
            </div>
            <div class="col-9">
                <div class="tab-content" id="v-pills-tabContent">
                <router-view></router-view>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserApi from "../../api/server/user";

export default {
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.list = await UserApi.list();
        },
        checkIfActive(name) {
            var self = this;
            if(self.$route.name == name) return "active";
        }
    },
    data() {
        return {
            list: []
        };
    }
};
</script>
